// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: fixed;
  top: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}
.modal-wrapper .modal {
  position: absolute;
  color: rgb(0, 0, 0);
  -webkit-box-shadow: 0 0 20px 0 black, 0 0 0px 0px black, 0 0 250px 100px rgba(0, 0, 0, 0.4);
          box-shadow: 0 0 20px 0 black, 0 0 0px 0px black, 0 0 250px 100px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  z-index: 11;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  font-size: 14px;
  min-width: 200px;
}
.modal-wrapper .modal h1 {
  font-size: 2em;
}
.modal-wrapper .modal p {
  text-align: left;
  font-family: "Noto Sans", sans-serif;
  font-size: 1em;
  line-height: 1.5em;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  width: 100%;
}
.modal-wrapper .modal p.lead {
  font-style: italic;
}
.modal-wrapper .modal h1,
.modal-wrapper .modal p {
  margin-bottom: 0.5em;
}
.modal-wrapper .modal.enter {
  -webkit-animation: in 0.5s;
          animation: in 0.5s;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
}
.modal-wrapper .modal.leave {
  -webkit-animation: out 0.5s;
          animation: out 0.5s;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
}
.modal-wrapper .modal .title {
  color: rgb(0, 0, 0);
}
.modal-wrapper .modal .body {
  padding: 15px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  max-height: 90vh;
  max-width: 90vw;
  overflow: auto;
  border-radius: 5px;
  -webkit-box-shadow: inset 0px -4px 0px 0px rgba(0, 0, 0, 0.2), inset 0px 2px 0px 0px rgba(255, 255, 255, 0.25);
          box-shadow: inset 0px -4px 0px 0px rgba(0, 0, 0, 0.2), inset 0px 2px 0px 0px rgba(255, 255, 255, 0.25);
  background: rgb(255, 255, 255);
  background-image: linear-gradient(2deg, #e3e2e2, #efefef 70%, #e8e8e8);
}
.modal-wrapper .modal .body .content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
}
.modal-wrapper .modal .body .content .row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
}
.modal-wrapper .modal .body .content .column {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}
.modal-wrapper .modal .body .content .column .actions {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 5px;
}
.modal-wrapper .modal .body .content .column .actions button,
.modal-wrapper .modal .body .content .column .actions a.button {
  margin: 0;
}
.modal-wrapper .modal .body .content .column h3 {
  font-size: 16px;
}
.modal-wrapper .modal .close {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
  height: 25px;
  width: 25px;
  right: -25px;
  background: rgb(229, 229, 229);
  top: 0;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  cursor: pointer;
}
.modal-wrapper .modal .close svg {
  height: 15px;
  width: 15px;
}
.modal-wrapper .modal .close svg path {
  stroke: black;
  stroke-width: 3px;
}
.modal-wrapper .overlay {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: brightness(0.5) contrast(0.9) blur(1px);
          backdrop-filter: brightness(0.5) contrast(0.9) blur(1px);
  z-index: 10;
}
.modal-wrapper .overlay.enter {
  -webkit-animation: fade-in 0.6s;
          animation: fade-in 0.6s;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
}
.modal-wrapper .overlay.leave {
  -webkit-animation: fade-out 0.6s;
          animation: fade-out 0.6s;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
}
@media screen and (max-width: 720px) {
  .modal-wrapper .modal .close {
    right: 0;
    top: -25px;
  }
}

@-webkit-keyframes in {
  0% {
    -webkit-transform: translate(0, -50px) rotateX(10deg);
            transform: translate(0, -50px) rotateX(10deg);
    -webkit-transform-origin: center;
            transform-origin: center;
    -webkit-filter: brightness(0.5);
            filter: brightness(0.5);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0px) rotateX(0deg);
            transform: translate(0, 0px) rotateX(0deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    -webkit-filter: brightness(1);
            filter: brightness(1);
    opacity: 1;
  }
}

@keyframes in {
  0% {
    -webkit-transform: translate(0, -50px) rotateX(10deg);
            transform: translate(0, -50px) rotateX(10deg);
    -webkit-transform-origin: center;
            transform-origin: center;
    -webkit-filter: brightness(0.5);
            filter: brightness(0.5);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate(0, 0px) rotateX(0deg);
            transform: translate(0, 0px) rotateX(0deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    -webkit-filter: brightness(1);
            filter: brightness(1);
    opacity: 1;
  }
}
@-webkit-keyframes out {
  0% {
    -webkit-transform: translate(0, 0px) rotateX(0deg);
            transform: translate(0, 0px) rotateX(0deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    -webkit-filter: brightness(1);
            filter: brightness(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(0, -50px) rotateX(10deg);
            transform: translate(0, -50px) rotateX(10deg);
    -webkit-transform-origin: center;
            transform-origin: center;
    -webkit-filter: brightness(0.5);
            filter: brightness(0.5);
    opacity: 0;
  }
}
@keyframes out {
  0% {
    -webkit-transform: translate(0, 0px) rotateX(0deg);
            transform: translate(0, 0px) rotateX(0deg);
    -webkit-transform-origin: bottom;
            transform-origin: bottom;
    -webkit-filter: brightness(1);
            filter: brightness(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(0, -50px) rotateX(10deg);
            transform: translate(0, -50px) rotateX(10deg);
    -webkit-transform-origin: center;
            transform-origin: center;
    -webkit-filter: brightness(0.5);
            filter: brightness(0.5);
    opacity: 0;
  }
}
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modal.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,eAAA;EACA,MAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,2FAAA;UAAA,mFAAA;EAEA,kBAAA;EACA,WAAA;EACA,4BAAA;EAAA,oBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAGI;EACE,gBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,WAAA;AADN;AAGM;EACE,kBAAA;AADR;AAKI;;EAEE,oBAAA;AAHN;AAMI;EACE,0BAAA;UAAA,kBAAA;EACA,iCAAA;UAAA,yBAAA;AAJN;AAOI;EACE,2BAAA;UAAA,mBAAA;EACA,iCAAA;UAAA,yBAAA;AALN;AAQI;EACE,mBAAA;AANN;AASI;EACE,aAAA;EACA,8BAAA;UAAA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,8GAAA;UAAA,sGAAA;EAEA,8BAAA;EACA,sEAAA;AARN;AAUM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,qBAAA;MAAA,iBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,SAAA;AARR;AAUQ;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,8BAAA;EAAA,6BAAA;MAAA,uBAAA;UAAA,mBAAA;EACA,qBAAA;MAAA,iBAAA;EACA,SAAA;EACA,WAAA;AARV;AAWQ;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,mBAAA;MAAA,WAAA;UAAA,OAAA;AATV;AAWU;EACE,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,QAAA;AATZ;AAWY;;EAEE,SAAA;AATd;AAaU;EACE,eAAA;AAXZ;AAiBI;EACE,kBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,MAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,eAAA;AAfN;AAiBM;EACE,YAAA;EACA,WAAA;AAfR;AAiBQ;EACE,aAAA;EACA,iBAAA;AAfV;AAqBE;EACE,eAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,gEAAA;UAAA,wDAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,+BAAA;UAAA,uBAAA;EACA,iCAAA;UAAA,yBAAA;AAnBN;AAsBI;EACE,gCAAA;UAAA,wBAAA;EACA,iCAAA;UAAA,yBAAA;AApBN;AAwBE;EACE;IACE,QAAA;IACA,UAAA;EAtBJ;AACF;;AA0BA;EACE;IACE,qDAAA;YAAA,6CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,+BAAA;YAAA,uBAAA;IACA,UAAA;EAvBF;EAyBA;IACE,kDAAA;YAAA,0CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,6BAAA;YAAA,qBAAA;IACA,UAAA;EAvBF;AACF;;AAWA;EACE;IACE,qDAAA;YAAA,6CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,+BAAA;YAAA,uBAAA;IACA,UAAA;EAvBF;EAyBA;IACE,kDAAA;YAAA,0CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,6BAAA;YAAA,qBAAA;IACA,UAAA;EAvBF;AACF;AA0BA;EACE;IACE,kDAAA;YAAA,0CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,6BAAA;YAAA,qBAAA;IACA,UAAA;EAxBF;EA0BA;IACE,qDAAA;YAAA,6CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,+BAAA;YAAA,uBAAA;IACA,UAAA;EAxBF;AACF;AAYA;EACE;IACE,kDAAA;YAAA,0CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,6BAAA;YAAA,qBAAA;IACA,UAAA;EAxBF;EA0BA;IACE,qDAAA;YAAA,6CAAA;IACA,gCAAA;YAAA,wBAAA;IACA,+BAAA;YAAA,uBAAA;IACA,UAAA;EAxBF;AACF;AA2BA;EACE;IACE,UAAA;EAzBF;EA2BA;IACE,UAAA;EAzBF;AACF;AAmBA;EACE;IACE,UAAA;EAzBF;EA2BA;IACE,UAAA;EAzBF;AACF;AA4BA;EACE;IACE,UAAA;EA1BF;EA4BA;IACE,UAAA;EA1BF;AACF;AAoBA;EACE;IACE,UAAA;EA1BF;EA4BA;IACE,UAAA;EA1BF;AACF","sourcesContent":[".modal-wrapper {\n  display: flex;\n  position: fixed;\n  top: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  z-index: 100;\n\n  .modal {\n    position: absolute;\n    color: rgb(0 0 0);\n    box-shadow: 0 0 20px 0 black, 0 0 0px 0px black,\n      0 0 250px 100px rgb(0 0 0 / 40%);\n    border-radius: 5px;\n    z-index: 11;\n    transition: all 0.3s;\n    font-size: 14px;\n    min-width: 200px;\n\n    h1 {\n      font-size: 2em;\n    }\n\n    p {\n      text-align: left;\n      font-family: 'Noto Sans', sans-serif;\n      font-size: 1em;\n      line-height: 1.5em;\n      flex: 1;\n      width: 100%;\n\n      &.lead {\n        font-style: italic;\n      }\n    }\n\n    h1,\n    p {\n      margin-bottom: 0.5em;\n    }\n\n    &.enter {\n      animation: in 0.5s;\n      animation-fill-mode: both;\n    }\n\n    &.leave {\n      animation: out 0.5s;\n      animation-fill-mode: both;\n    }\n\n    .title {\n      color: rgb(0 0 0);\n    }\n\n    .body {\n      padding: 15px;\n      box-sizing: border-box;\n      max-height: 90vh;\n      max-width: 90vw;\n      overflow: auto;\n      border-radius: 5px;\n      box-shadow: inset 0px -4px 0px 0px rgb(0 0 0 / 20%),\n        inset 0px 2px 0px 0px rgb(255 255 255 / 25%);\n      background: rgb(255 255 255);\n      background-image: linear-gradient(2deg, #e3e2e2, #efefef 70%, #e8e8e8);\n\n      .content {\n        display: flex;\n        flex-direction: column;\n        flex-wrap: nowrap;\n        align-items: center;\n        gap: 10px;\n\n        .row {\n          display: flex;\n          flex-direction: row;\n          flex-wrap: nowrap;\n          gap: 10px;\n          width: 100%;\n        }\n\n        .column {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          flex: 1;\n\n          .actions {\n            flex-direction: column;\n            gap: 5px;\n\n            button,\n            a.button {\n              margin: 0;\n            }\n          }\n\n          h3 {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    .close {\n      position: absolute;\n      display: flex;\n      text-align: center;\n      height: 25px;\n      width: 25px;\n      right: -25px;\n      background: rgb(229 229 229);\n      top: 0;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n\n      svg {\n        height: 15px;\n        width: 15px;\n\n        path {\n          stroke: black;\n          stroke-width: 3px;\n        }\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    height: 100vh;\n    width: 100vw;\n    background: rgb(0 0 0 / 20%);\n    backdrop-filter: brightness(0.5) contrast(0.9) blur(1px);\n    z-index: 10;\n\n    &.enter {\n      animation: fade-in 0.6s;\n      animation-fill-mode: both;\n    }\n\n    &.leave {\n      animation: fade-out 0.6s;\n      animation-fill-mode: both;\n    }\n  }\n\n  @media screen and (max-width: 720px) {\n    .modal .close {\n      right: 0;\n      top: -25px;\n    }\n  }\n}\n\n@keyframes in {\n  0% {\n    transform: translate(0, -50px) rotateX(10deg);\n    transform-origin: center;\n    filter: brightness(0.5);\n    opacity: 0;\n  }\n  100% {\n    transform: translate(0, 0px) rotateX(0deg);\n    transform-origin: bottom;\n    filter: brightness(1);\n    opacity: 1;\n  }\n}\n\n@keyframes out {\n  0% {\n    transform: translate(0, 0px) rotateX(0deg);\n    transform-origin: bottom;\n    filter: brightness(1);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, -50px) rotateX(10deg);\n    transform-origin: center;\n    filter: brightness(0.5);\n    opacity: 0;\n  }\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-out {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
